import { render, staticRenderFns } from "./MarkdownMarkedText.vue?vue&type=template&id=34c47c76&scoped=true"
import script from "./MarkdownMarkedText.vue?vue&type=script&lang=js"
export * from "./MarkdownMarkedText.vue?vue&type=script&lang=js"
import style0 from "./MarkdownMarkedText.vue?vue&type=style&index=0&id=34c47c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c47c76",
  null
  
)

export default component.exports